import {
  CHOICE,
  CORE,
  DELUXE,
  ECONOMY,
  EPIC,
  SURE_CARE,
  QUANTUM,
  STANDARD
} from 'core/constants/products'

const descriptionType = {
  [CHOICE]: 'Cost-effective coverage w/ doctor & Urgent Care copay benefits.',
  [ECONOMY]: 'Basic coverage at a budget-friendly price.',
  [DELUXE]: 'Prescription drug benefits with no-deductible for generics.',
  [STANDARD]: 'Standard plan with lower out-of-pocket limit.',
  [CORE]: 'Health plans with doctor copays and low deductibles.',
  [QUANTUM]:
    'Access to one of the nation’s largest PPO networks with preventive care coverage and low Rx copays.',
  [`${EPIC}-PPO-01`]: 'National network with benefits for preventive care', // ppo without RX
  [`${EPIC}-PPO-04`]: 'National network with prescription drug copays', // ppo with RX
  [`${EPIC}-Non-PPO-01`]: 'All Provider Access with benefits for preventive care', // base without RX
  [`${EPIC}-Non-PPO-04`]: 'All Provider Access with prescription drug copays', // base with RX
  [SURE_CARE]:
    'Lower deductible option with preventive care screenings and no copays for emergency room care.'
}

function getPlanDetailTooltip(plan, isEpic) {
  let key = plan.productId

  if (isEpic) {
    key += `-${plan.coreBenefits.network}-${plan.coreBenefits.rxSchedule}`
  }

  return descriptionType[key]
}

export default getPlanDetailTooltip
